import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useT } from "../context/I18nContext";
import { FileText, ImageIcon, LogOut, Sparkles, Target } from "lucide-react";
import { Button } from "./ui/button";
import LangSwitcher from "./LangSwitcher";

export default function Navbar() {
  const { user, logout } = useAuth();
  const t = useT();
  const nav = useNavigate();

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-md bg-white/80 border-b border-[#E2DBCE]"
      data-testid="app-navbar"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="w-8 h-8 rounded-md bg-[#0F172A] text-[#FDFBF7] grid place-items-center">
            <Sparkles size={16} />
          </span>
          <span className="font-serif-display text-lg tracking-tight">
            <span className="font-bold">image to pdf</span>
            <span className="text-[#881337]"> + classic cv</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 text-sm">
          <Link to="/tools/job-match" data-testid="nav-link-job-match"
            className="px-3 py-2 rounded-md bg-[#0F172A] text-white hover:bg-[#1E293B] flex items-center gap-2">
            <Target size={14}/> {t("nav.jobMatch")}
          </Link>
          <Link to="/tools/cv-builder" data-testid="nav-link-cv-builder"
            className="px-3 py-2 rounded-md hover:bg-[#F4F0EA] flex items-center gap-2">
            <FileText size={14}/> {t("nav.cvBuilder")}
          </Link>
          <Link to="/tools/image-to-pdf" data-testid="nav-link-image-to-pdf"
            className="px-3 py-2 rounded-md hover:bg-[#F4F0EA] flex items-center gap-2">
            <ImageIcon size={14}/> {t("nav.imagePdf")}
          </Link>
          {user && (
            <Link to="/dashboard" data-testid="nav-link-dashboard"
              className="px-3 py-2 rounded-md hover:bg-[#F4F0EA]">{t("nav.dashboard")}</Link>
          )}
        </nav>

        <div className="flex items-center gap-2">
          <LangSwitcher />
          {user ? (
            <>
              <span className="pill hidden sm:inline-flex" data-testid="user-credit-balance-text">
                <span className="w-2 h-2 rounded-full bg-[#D97706]" /> {user.credits} {t("common.credits")}
              </span>
              <Button
                variant="outline"
                size="sm"
                onClick={() => { logout(); nav("/"); }}
                data-testid="logout-button"
                className="border-[#E2DBCE]"
              >
                <LogOut size={14} className="mr-1" /> {t("nav.logout")}
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-login-link"
                className="text-sm px-3 py-2 rounded-md hover:bg-[#F4F0EA]">{t("nav.login")}</Link>
              <Link to="/register" data-testid="nav-register-link">
                <Button size="sm" className="bg-[#0F172A] hover:bg-[#1E293B]">{t("nav.getStarted")}</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
